var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
function _objectWithoutProperties(obj, keys) {
  var target = {};
  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }
  return target;
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import addSuffix from '../utils/StringUtils/addSuffix';
import isValued from '../utils/isValued';
import FloatingLabel from '../TextFields/FloatingLabel';
import TextFieldMessage from '../TextFields/TextFieldMessage';
import SelectFieldInput from './SelectFieldInput';
var SelectFieldToggle = function (_PureComponent) {
  _inherits(SelectFieldToggle, _PureComponent);
  function SelectFieldToggle() {
    _classCallCheck(this, SelectFieldToggle);
    return _possibleConstructorReturn(this, _PureComponent.apply(this, arguments));
  }
  SelectFieldToggle.prototype.render = function render() {
    var _props = this.props,
      id = _props.id,
      style = _props.style,
      className = _props.className,
      inputStyle = _props.inputStyle,
      inputClassName = _props.inputClassName,
      required = _props.required,
      disabled = _props.disabled,
      active = _props.active,
      error = _props.error,
      errorText = _props.errorText,
      helpText = _props.helpText,
      helpOnFocus = _props.helpOnFocus,
      visible = _props.visible,
      activeLabel = _props.activeLabel,
      propLabel = _props.label,
      propPlaceholder = _props.placeholder,
      props = _objectWithoutProperties(_props, ['id', 'style', 'className', 'inputStyle', 'inputClassName', 'required', 'disabled', 'active', 'error', 'errorText', 'helpText', 'helpOnFocus', 'visible', 'activeLabel', 'label', 'placeholder']);
    var _props2 = this.props,
      label = _props2.label,
      placeholder = _props2.placeholder;
    if (required) {
      if (label) {
        label = addSuffix(label, '*');
      }
      if (placeholder && !label) {
        placeholder = addSuffix(placeholder, '*');
      }
    }
    return React.createElement('div', {
      style: style,
      className: cn('md-select-field__toggle', className)
    }, React.createElement(FloatingLabel, {
      label: label,
      htmlFor: id,
      active: active || visible,
      error: error,
      floating: isValued(activeLabel) || active || visible,
      disabled: disabled
    }), React.createElement(SelectFieldInput, _extends({}, props, {
      id: id,
      style: inputStyle,
      className: inputClassName,
      label: label,
      placeholder: placeholder,
      activeLabel: activeLabel,
      active: active,
      error: error,
      disabled: disabled
    })), React.createElement(TextFieldMessage, {
      active: active || visible,
      error: error,
      errorText: errorText,
      helpText: helpText,
      helpOnFocus: helpOnFocus,
      leftIcon: false,
      rightIcon: false
    }));
  };
  return SelectFieldToggle;
}(PureComponent);
SelectFieldToggle.propTypes = {
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  style: PropTypes.object,
  className: PropTypes.string,
  inputStyle: PropTypes.object,
  inputClassName: PropTypes.string,
  activeLabel: PropTypes.node,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  active: PropTypes.bool,
  error: PropTypes.bool,
  errorText: PropTypes.node,
  helpText: PropTypes.node,
  helpOnFocus: PropTypes.bool,
  below: PropTypes.bool,
  visible: PropTypes.bool
};
export default SelectFieldToggle;